import { Redirect } from 'react-router-dom';
import { node } from 'prop-types';
import { useState, useEffect } from 'react';

import { hasPaymentPermission } from 'utils/userInfo';
import AuthGuard from './AuthGuard';

function PaymentsGuard({ children }) {
  const [hasPermission, setHasPermission] = useState(hasPaymentPermission());

  useEffect(() => {
    setHasPermission(hasPaymentPermission());
  }, []);

  if (!hasPermission) {
    return <Redirect to="/home" />;
  }

  return children;
}

PaymentsGuard.propTypes = {
  children: node,
};

function CombinedPaymentsGuard({ children }) {
  return (
    <AuthGuard>
      <PaymentsGuard>{children}</PaymentsGuard>
    </AuthGuard>
  );
}

CombinedPaymentsGuard.propTypes = {
  children: node,
};

export default CombinedPaymentsGuard;
